import { useState } from 'react';

interface Props {
  nombre: string;
  estado: 'borrador' | 'pendiente_validacion' | 'cerrado';
  submitting?: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Modal de confirmación destructiva con "type-to-confirm". El usuario debe
 * escribir el nombre exacto del archivo para habilitar el botón final.
 */
export function EliminarPadronModal({
  nombre,
  estado,
  submitting,
  error,
  onCancel,
  onConfirm,
}: Props) {
  const [typed, setTyped] = useState('');
  const valid = typed.trim() === nombre;

  return (
    <div className="modalBackdrop" onClick={onCancel}>
      <div className="modalCard" style={{ maxWidth: 520 }} onClick={(e) => e.stopPropagation()}>
        <header style={{ marginBottom: 16 }}>
          <h2 className="heading-3" style={{ color: 'var(--color-error-dark)' }}>
            Eliminar padrón
          </h2>
          <p className="text-element-mid" style={{ marginTop: 6, fontSize: 14 }}>
            Esta acción <strong>no se puede deshacer</strong>. Se van a borrar
            permanentemente:
          </p>
          <ul
            className="text-element-mid"
            style={{ marginTop: 8, marginLeft: 20, fontSize: 13, lineHeight: 1.6 }}
          >
            <li>
              El padrón <strong>{nombre}</strong>{' '}
              <span
                className={
                  estado === 'cerrado'
                    ? 'status status-info'
                    : 'status status-warning'
                }
                style={{ marginLeft: 4 }}
              >
                {estado}
              </span>
            </li>
            <li>Todas las filas (asociados) del padrón</li>
            <li>Todos los legajos creados al cerrar (si aplica)</li>
          </ul>
        </header>

        <label className="formField" style={{ display: 'block', marginTop: 12 }}>
          <span style={{ display: 'block', marginBottom: 6, fontSize: 13 }}>
            Para confirmar, escribí exactamente el nombre del archivo:
          </span>
          <code
            style={{
              display: 'block',
              padding: '6px 10px',
              background: 'var(--color-surface-accent)',
              borderRadius: 6,
              fontSize: 12,
              marginBottom: 8,
              wordBreak: 'break-all',
            }}
          >
            {nombre}
          </code>
          <input
            className="input"
            type="text"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder="Escribí el nombre exacto"
            autoFocus
            disabled={submitting}
          />
        </label>

        {error && (
          <p
            className="status status-error"
            style={{ marginTop: 12, display: 'block' }}
          >
            {error}
          </p>
        )}

        <div className="rowBetween" style={{ marginTop: 20 }}>
          <button
            className="btn btn-ghost"
            onClick={onCancel}
            disabled={submitting}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            disabled={!valid || submitting}
            onClick={onConfirm}
            style={{ background: 'var(--color-error-dark)' }}
          >
            <span className="btn-font-style">
              {submitting ? 'Eliminando…' : 'Eliminar permanentemente'}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
